import React, { memo } from 'react';

import { Alert, Table, Typography } from 'antd';

import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import { CHECKOUT_ELEMENTS_URL } from 'settings';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  productId: number | string;
}

const ShareableLinks = ({ productId }: IProps) => {
  return (
    <div className='my-6 flex flex-col gap-3'>
      <Typography.Title level={5}>Link para divulgação</Typography.Title>

      <Alert
        icon={<Icon.Info />}
        type='info'
        message='Seus novos links de Checkout, agora, seguem o padrão de oferta base do MyEduzz. Essa alteração não compromete seus links já criados.'
      />

      <div className='mt-4 flex flex-col gap-2 md:hidden'>
        <Typography.Text>Eduzz Checkout Elements</Typography.Text>
        <CustomCopyToClipboard text={`${CHECKOUT_ELEMENTS_URL}/${productId}`} hideInput />
      </div>

      <div className='hidden md:block'>
        <Table
          pagination={false}
          rowKey='label'
          columns={[
            { title: 'Checkout', dataIndex: 'label' },
            {
              title: 'Página de pagamento',
              dataIndex: 'url',
              render: (url: string) => <CustomCopyToClipboard text={url} hideInput />
            }
          ]}
          dataSource={[{ label: 'Eduzz Checkout Elements', url: `${CHECKOUT_ELEMENTS_URL}/${productId}` }]}
        />
      </div>
    </div>
  );
};

export default memo(ShareableLinks);
